import React from 'react';
import Select2 from 'react-select2-wrapper';
import _, { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import 'select2/dist/css/select2.min.css';
import './multiselect.scss';

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import Error from '../error';

const Tooltip = asyncRoute(() => import('../../../components/FormElements/ToolTip'));

const index = (props) => {

  const { onChange, disabled, setting, submited, touched, error, value, allowClear, toggle, options = [], onBlur = () => { }, } = props;
  const { labelLayout = 'col-sm-4', addModel = false, editModel = false } = setting
  return (<div className="form-group row">
    {setting.label && <label htmlFor={setting.key} className={`${labelLayout} col-form-label`}>{setting.label}{" "}{(setting.required) ? "" : <><br /><span className="small" style={{ color: "#1925238a" }}>Optional</span></>}</label>}
    <div className={isEmpty(error) ? `${setting.displayLayout} select2-custom-multiselect ` : `${setting.displayLayout} select2-custom-multiselect has-error`}>
      <Select2
        className={"form-control"}
        data={options}
        value={value}
        name={setting.key}
        disabled={disabled}
        onSelect={() => { onBlur({ target: { name: setting.key, value: value } }) }}
        onOpen={() => { onBlur({ target: { name: setting.key, value: value } }) }}
        onChange={onChange}
        options={{
          placeholder: setting.placeholder,
          allowClear: allowClear
        }}
        style={{ width: "100%" }}
      />
      {(submited || touched) && (<Error setting={setting} error={error} />)}
    </div>
    {setting.tooltip && <Tooltip text={setting.tooltip} />}
    {addModel && <i onClick={() => toggle('add')} className="mdi mdi-plus-box mdi-24px btnSelectCursor"></i>}
    {editModel && <i onClick={() => toggle('edit')} className={`${value === '' ? 'disabled' : ''}  mdi mdi-pencil-box mdi-24px btnSelectCursor`}></i>}
  </div>)
}

const onChangeTarget = (e, onChange, setting) => {
  // let options = option;
  // console.log(e, onChange, setting)
  // let selected = [];
  // for (let i = 0, l = options.length; i < l; i++) {
  //   if (options[i].selected) {
  //     selected.push(options[i].value);
  //   }
  // }
  // onChange({ target: { name: setting.key, value: selected } });
}

export default index;


// ----* input propTypes set *----
index.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.array,

  // -----* setting PropTypes *----
  setting: PropTypes.shape({
    required: PropTypes.bool,
    label: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    tooltip: PropTypes.string,
    touched: PropTypes.object,
    allowClear: PropTypes.bool
  }),

  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    // PropTypes.instanceOf('adsfjkdslfjlakdfsj456456456')
  ]),
}

// * ----- index defaultProps  set * -----
index.defaultProps = {
  options: [],
  value: [],
  allowClear: true
};